/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProductCodeUploadStatus, updateProductManagerConfig } from 'state/thunks/productmanager';
// utils
// material
import { Button, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './confirmpublishmodal_styles';
import { Loader } from '@insticator/insticator-ui/dist/material';

/* ========== ~~~~~~~~~~ MODERATION CONFIG PAGE ~~~~~~~~~~ ========== */
const ConfirmPublishModal  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { tempProductManagerConfig } = useSelector(state => state.productManager)
  const { siteUUID } = useSelector(state => state.session);

  const { groupIndex, action, onPublish, onCancel } = props

  const [isProcessing, setIsProcessing] = useState(false)
  const [status, setStatus] = useState(null)


  const handleCancel = () => {
    dispatch(displayModal(false))
    onCancel?.()
  }

  const refetchStatus = useCallback(async () => {
    console.log('fetching status')
    const response = await dispatch(getProductCodeUploadStatus({ siteId: siteUUID }))
    if(response.error) {
      setIsProcessing(false)
      setStatus('FAILED')
    } else {
      setStatus(response?.payload || 'FAILED')

      if(response.payload === 'SUCCESS' || response.payload === 'FAILED') {
        setIsProcessing(false)
        setStatus(response.payload)
      }
  
      if(response.payload === 'IN_PROGRESS') {
        setTimeout(() => {
          refetchStatus()
        }, [7000])
      }
    }

  }, [dispatch, onPublish, siteUUID])

  const handlePublish = useCallback(async () => {
    setIsProcessing(true)
    let response;

    const updatedGroups = JSON.parse(JSON.stringify(tempProductManagerConfig.groupConfigList))
    updatedGroups.forEach((updatedGroup, groupIndex) => {
      updatedGroups[groupIndex]['current'] = updatedGroups[groupIndex]['draft']
      const currentButtonConfigUUID = tempProductManagerConfig.groupConfigList[groupIndex].current.buttonConfig?.uuid || null
      // Current Button Config and Draft Button Config should have different UUIDs
      if(updatedGroups[groupIndex]['current'].buttonConfig) {
        // if the copied uuid is the same, used the current button uuid
        if(updatedGroups[groupIndex]['current'].buttonConfig.uuid === updatedGroups[groupIndex]['draft'].buttonConfig.uuid) {
          updatedGroups[groupIndex]['current'].buttonConfig.uuid = currentButtonConfigUUID
        }
      }
    })
    const updatedTempProductManagerConfig = {...tempProductManagerConfig, publishConfigs: true, groupConfigList: updatedGroups}
    response =  await dispatch(updateProductManagerConfig({ productManagerConfig: updatedTempProductManagerConfig, siteId: siteUUID }))

    if(response.payload && !response.payload.errorCode) {
      setTimeout(() => {
        refetchStatus()
      }, [15000])
    } else {
      setIsProcessing(false)
      setStatus('FAILED')
    }

  }, [action, dispatch, groupIndex, refetchStatus, siteUUID, tempProductManagerConfig])


  if(isProcessing) return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <Loader />
      <h4>Changes processing...</h4>
      <p style={{ textAlign: 'center', fontSize: '14px'}}>Changes are taking effect, please don’t refresh the page.</p>
    </Space>
  )

  if(status === 'SUCCESS') return (
   <div className={'confirmpublishmodal'}>
      <h4>Success!</h4>
      <p>Your changes have been published to the live site and are now visible to end-users.</p>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text='Close' variant='none' color='light' handleClick={handleCancel} />
      </Space>   
    </div>
  )

  if(status === 'FAILED') return (
    <div className={'confirmpublishmodal'}>
      <h4>We’re Sorry</h4>
      <p>Looks like something went wrong. We were not able to publish your changes. Please try again.</p>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text='Cancel' variant='none' color='light' handleClick={handleCancel} />
        <Button 
          text='Try again' 
          variant='primary' 
          disabled={isProcessing} 
          processing={isProcessing} 
          handleClick={handlePublish} 
        />      
      </Space>   
    </div>
  )


  return (
    <div className={'confirmpublishmodal'}>
      <h4>Are you sure?</h4>
        <p>
          This action will publish <strong>all changes</strong> to the client’s site. 
          Ensure each available product has been configured, assigned ads, and thoroughly tested.
        </p>
        <br />
        <p className='errormessage'>Note: Changes may need a few minutes to take effect. If you don’t see your changes reflected, try again.</p>
        <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
          <Button text='Cancel' variant='none' color='light' handleClick={handleCancel} />
          <Button 
            text='Confirm' 
            variant='primary' 
            disabled={isProcessing} 
            processingText={'Pulishing changes'} 
            processing={isProcessing} 
            handleClick={handlePublish} 
          />
        </Space>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ConfirmPublishModal